// eslint-disable-next-line no-unused-vars
import { sendRequest } from "./apiServices/apiConnector";

export const service_fetchRevenue = () => {
	return sendRequest(`/statistics/revenue`).then(response => response.json());
};
